<div class="purchase-confirmation">
    <p class="title-caption">{{ 'confirmation.header' | translate }}</p>
    <p class="message-caption">{{ 'confirmation.message-1' | translate }}</p>
    <p class="sub-message-caption">{{ 'confirmation.message-2' | translate }}</p>
    <p class="sub-message-caption">{{ 'confirmation.message-3' | translate }}</p>
</div>
<div class="ffp-membership-form" *ngIf="requiresFfpMembership">
    <form [formGroup]="ffpForm" (ngSubmit)="submitFfpMembership()">
        <div class="calculator-form-title-small mb-2">{{ 'confirmation.membership-header' | translate }}</div>
        <p class="ffp-membership-description">{{ 'confirmation.membership-description' | translate }}</p>
        <div class="ffp-fields-grid">
            <div class="ffp-field">
                <label for="membershipNumber">{{ 'confirmation.membership-number-caption' | translate }}</label>
                <input
                    type="text"
                    name="membershipNumber"
                    class="form-control"
                    placeholder="{{ 'confirmation.membership-number-placeholder' | translate }}"
                    [formControl]="ffpForm.controls['membershipNumber']"
                />
            </div>
            <div class="ffp-field">
                <label for="givenName">{{ 'confirmation.given-name-caption' | translate }}</label>
                <input
                    type="text"
                    name="givenName"
                    class="form-control"
                    placeholder="{{ 'confirmation.given-name-placeholder' | translate }}"
                    [formControl]="ffpForm.controls['givenName']"
                />
            </div>
            <div class="ffp-field">
                <label for="familyName">{{ 'confirmation.family-name-caption' | translate }}</label>
                <input
                    type="text"
                    name="familyName"
                    class="form-control"
                    placeholder="{{ 'confirmation.family-name-placeholder' | translate }}"
                    [formControl]="ffpForm.controls['familyName']"
                />
            </div>
        </div>
        <p class="ffp-name-example" [innerHTML]="'confirmation.membership-name-example-link-caption' | translate"></p>
        <p class="ffp-result-message ffp-result-success" *ngIf="ffpSubmitted">
            {{ 'confirmation.membership-submit-success' | translate }}
        </p>
        <p class="ffp-result-message ffp-result-error" *ngIf="ffpError">
            {{ 'confirmation.membership-submit-error' | translate }}
        </p>
        <div class="ffp-privacy-consent">
            <input
                type="checkbox"
                id="privacyConsent"
                name="privacyConsent"
                [formControl]="ffpForm.controls['privacyConsent']"
            />
            <label for="privacyConsent" [innerHTML]="'confirmation.membership-privacy-consent' | translate"></label>
        </div>
        <div class="ffp-links-row">
            <span class="ffp-apply-link">
                {{ 'confirmation.membership-apply-message' | translate }}
                <span [innerHTML]="'confirmation.membership-apply-link-caption' | translate"></span>
            </span>
            <span class="ffp-inquiry-link" [innerHTML]="'confirmation.membership-inquiry-link-caption' | translate"></span>
        </div>
        <div class="ffp-submit-row">
            <button type="submit" class="next-button" [disabled]="!ffpForm.valid || ffpSubmitting || ffpSubmitted">
                {{ 'confirmation.membership-submit-caption' | translate }}
            </button>
        </div>
    </form>
</div>
<div class="shared">
    <p class="message-caption">{{ 'confirmation.message-4' | translate }}</p>
    <p class="share-message-caption">{{ shareMessageHtml }}</p>
    <app-share-offsets [siteUrl]="siteUrl" [tonnes]="tonnes" [shareMessage]="shareMessage"></app-share-offsets>
</div>
<div>
    <app-post-purchase-navigation
        [target]="data.id"
        [hasNext]="false"
        (back)="back()">
    </app-post-purchase-navigation>
</div>
